import React from 'react'
import BannerWrapper from './BannerWrapper'

const Banner = ({ imgUrl }) => {

    return (
        <BannerWrapper>
            <img src={imgUrl} style={{width: '100%'}} />
        </BannerWrapper>
    )
}

export default Banner